import React from "react";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../constants/forms";
import { getFieldProps } from "../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

function ConservatorInfoBlock({ values = {}, onChange }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Conservator Information</span>
        </div>
      </Col>
      <Col xs={12} md={6}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.trusteeTitle)}
          value={values[FORM_FIELD_KEYS.trusteeTitle]}
          validated={values.validated}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.trusteeFirstName)}
          value={values[FORM_FIELD_KEYS.trusteeFirstName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.trusteeMiddleName)}
          value={values[FORM_FIELD_KEYS.trusteeMiddleName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.trusteeLastName)}
          value={values[FORM_FIELD_KEYS.trusteeLastName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12}>
        <MaskInput
          {...getFieldProps(FORM_FIELD_KEYS.trusteeSSN)}
          value={values[FORM_FIELD_KEYS.trusteeSSN]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default ConservatorInfoBlock;
